import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiDataService } from '~app/core/storage/base-api-data.service';
import { environment } from '~env';
const API_URL = environment.legalEntityCommandApi;

@Injectable({
  providedIn: 'root'
})
export class LegalEntityPracticeCommandService {

  get entityUrl(): string {
    return `${API_URL}/legalentity`;
  }

  constructor(private httpClient: HttpClient, private dataService: BaseApiDataService<any>) {}

  public genereateLegalEntityRegisterReport(
    legalEntityId: string
  ): Observable<any> {
    return this.dataService.post(
      `${this.entityUrl}/${legalEntityId}/exportToPdfFromPortail`,
      {}
    );
  }

  authorizeDocumentDownload(
    legalEntityId: string,
    documentId: string
  ): Observable<string> {
    return this.dataService
      .post(  
        `${this.entityUrl}/${legalEntityId}/documents/${documentId}/authorizedownload`,
        {}
      )
      .pipe(map((dto) => dto.location));
  }
}
